export const TRACKING_STATUS_MAP = {
  RCS: 'cargoReceived',
  FOH: 'cargoReceived',
  PRE: 'prepared',
  MAN: 'loaded',
  DEP: 'departed',
  departed: 'departed',
  AWR: 'awbIssued',
  ARR: 'arrived',
  arrived: 'arrived',
  RCF: 'atDestinationTerminal',
  NFD: 'consigneeNotified',
  DLV: 'delivered',
  AWD: 'completed',
  DIS: 'discrepancy',
  schedule: 'flightScheduled',
  canceled: 'flightCanceled',
};

export function toTrackingStatus (status) {
  if (!status) return null;
  const value = String(status);
  return TRACKING_STATUS_MAP[value] || TRACKING_STATUS_MAP[value.toUpperCase()] || null;
}
